import type * as React from "react"
import type { UseMeasureRef } from "react-use/lib/useMeasure"
import {
  DisplayEntry,
  type EntityCategory,
  type EntityParty,
  type EntityTransaction,
  EntryType,
  type TaxStatus,
  type Transaction,
} from "@digits-graphql/frontend/graphql-bearer"
import type { ColumnSort, OnChangeFn, SortingState } from "@tanstack/react-table"

export const TRANSACTION_ROW_CLASS = "transaction-row"

export type TableVariant = "summary" | "taxes" | "banksAndCards"

export type DefaultTableVariantProps = {
  variant?: "summary"
}

export type TransactionUpdates = Map<string, TransactionUpdate>
export type TransactionSelections = Map<string, Transaction>

export interface BulkUpdate {
  party?: EntityParty | undefined
  category?: EntityCategory | undefined
  splitCategory?: EntityCategory | undefined
  taxStatus?: TaxStatus | undefined
}

export interface TransactionUpdate extends BulkUpdate {
  transaction: Transaction
}

export type ColumnOptions = {
  enableSorting?: boolean
  partyIconOnly?: boolean
  includeSources?: boolean
  includeRelatedCategory?: boolean
}

export function isTransaction(data: EntityTransaction): data is Transaction {
  return data && "sources" in data
}

export function entryTypeFromDisplayType(displayEntry: DisplayEntry): EntryType {
  switch (displayEntry) {
    case DisplayEntry.Credit:
    case DisplayEntry.TransferCredit:
      return EntryType.Credit
    case DisplayEntry.Debit:
    case DisplayEntry.TransferDebit:
      return EntryType.Debit
    case DisplayEntry.Unknown:
      return EntryType.Unknown
  }
}

export interface TransactionsTableProps {
  ref?: React.RefObject<HTMLTableElement | null> | UseMeasureRef<HTMLTableElement>
  className?: string
  transactions: Transaction[] | undefined
  loading?: boolean
  collapsed?: boolean
  sorting?: ColumnSort[]
  onSortingChange?: OnChangeFn<SortingState>
}
